import { render } from "./Response.vue?vue&type=template&id=bfafc06e"
import script from "./Response.vue?vue&type=script&lang=js"
export * from "./Response.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__